import React from "react";
import { Box } from "@mui/material";
import { MotionFade, SectionContent, Container } from "..";

/**
 * ProjectSection
 * Standardizes section heading style and entrance animation.
 * Renders optional SectionContent followed by children.
 */
const ProjectSection = React.forwardRef(({
  id,
  title,
  content,
  titleVariant = "h2",
  titleColor = "primary.main",
  container = true,
  maxWidth = "xl",
  sx,
  children,
}, ref) => {
  const contentBlock = (
    <MotionFade>
      <Box id={id} ref={ref} sx={{ width: "100%" }}>
        {title && (
          <SectionContent
            title={title}
            titleVariant={titleVariant}
            titleColor={titleColor}
            content={content}
            animated={true}
            sx={{ mt: 6, ...(sx || {}) }}
          />
        )}
        {children}
      </Box>
    </MotionFade>
  );

  if (container) return <Container maxWidth={maxWidth}>{contentBlock}</Container>;
  return contentBlock;
});

export default ProjectSection;
